import styles from "./ExpandableButton.module.css";

import { ReactNode } from "react";

import { Plus, Minus } from "../icons";

interface ExpandableButtonProps {
  onClick: () => void;
  isExpanded: boolean;
  hasExpandableContent: boolean;
  children: ReactNode;
}

export const ExpandableButton = ({
  onClick,
  isExpanded,
  hasExpandableContent,
  children,
}: ExpandableButtonProps) => {
  return (
    <button
      type="button"
      className={`expandableButton ${styles.styledButton} ${hasExpandableContent ? styles.clickable : ""
        }`}
      onClick={() => hasExpandableContent && onClick()}
      disabled={!hasExpandableContent}
      aria-expanded={isExpanded}
    >
      {hasExpandableContent && (
        <span className={`${styles.iconContainer} iconContainer`}>
          <div className={styles.iconWrapper}>
            {isExpanded ? <Minus /> : <Plus />}
          </div>
        </span>
      )}
      {children}
    </button>
  );
};
